<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">菜品留样详情</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="InfoForm" :rules="rules" ref="InfoForm" disabled>
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品所属的日期" required prop="time">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="InfoForm.time"
                                        type="date"
                                        placeholder="请选择菜品所属的日期"
                                        value-format="yyyy-MM-dd"
                                        :clearable='false'
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="存放时间" required prop="startTime">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="InfoForm.startTime"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="请选择菜品存放时间"
                                        :clearable='false'
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品类别" required prop="dishesType">
                                    <el-select
                                        v-model="InfoForm.dishesType"
                                        placeholder="请选择菜品类别"
                                        style="width:100%">
                                        <el-option
                                            v-for="item in dishesTypeValue"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="菜品是否异常" required prop="status">
                                    <el-radio-group v-model="InfoForm.status" style="width:100%">
                                        <el-radio :label="0">正常</el-radio>
                                        <el-radio :label="1">异常</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="18" class="item">
                                <el-form-item label="菜品" required prop="dishesCodeArr">
                                    <div style="width:100%;margin-top:40px">
                                        <el-tag v-for="item in dishList" :key="item.name" style="margin-right:20px">{{item.name}}</el-tag>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="样品图片" required>
                                    <el-row style="margin-top:40px">
                                        <el-col :span='6' v-for="item in imgList" :key='item'>
                                            <img :src="imgUrl+item" class="imgLook" @click="imgPreview(imgUrl+item)">
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                            <el-col :span="18" class="item">
                                <el-form-item label="备注" required prop="remarks">
                                    <el-input v-model="InfoForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>
                 
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('InfoForm')">添加</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" top='30vh' :modal-append-to-body='false'>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-image-viewer
            v-if="imgDialog"
            :on-close="imgClose"
            :url-list="srcList" />
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

    export default {
        name: 'Info',
        props:['dishesList'],
        data() {
            return {
                loading: false,
                floor:null,
                InfoForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    time:'',
                    startTime:'',
                    remarks:'',
                    status:'',
                    dishesCodeArr:[],
                    dishesType:'',
                    dishesImg:'',
                },
                imgList:[],
                srcList:[],
                dishList:[],
                imgDialog:false,
                imgUrl:this.$imgUrl,
                dialogImageUrl:'',
                dialogVisible:false,
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                dishesTypeValue:['早餐','中餐','晚餐'],
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择菜品所属的日期', trigger: 'blur' },
                    ],
                    startTime:[
                        { required: true, message: '请选择菜品存放时间', trigger: 'blur' },
                    ],
                    dishesCodeArr:[
                        { required: true, message: '请选择留样的菜品', trigger: 'blur' },
                    ],
                    status:[
                        { required: true, message: '菜品是否异常', trigger: 'blur' },
                    ],
                    dishesType:[
                        { required: true, message: '请选择菜品类别', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入备注', trigger: 'blur' },
                    ],
                }
            }
        },
        components:{
            ElImageViewer
        },
        methods: {
            init(row){
                this.$refs.InfoForm.resetFields();
                this.InfoForm.time=row.time
                this.InfoForm.startTime=row.startTime
                this.InfoForm.remarks=row.remarks
                this.InfoForm.status=row.status
                this.InfoForm.dishesType=row.dishesType
                this.InfoForm.dishesImg=row.dishesImg
                this.imgList=row.dishesImg.split(",")
                for(var i in this.imgList){
                    this.srcList[i]=this.$imgUrl+this.imgList[i]
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesCheckRecord/GetDishesList",
                    data: {
                        staffCode:getStaffCode(),
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        dishesCheckRecordCode:row.dishesCheckRecordCode
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.dishList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            closeSelf() {
                this.$emit("closeInfo");
            },
            imgClose() {this.imgDialog = false;},
            imgPreview(url){
                this.srcList=this.getPreviewList(url)
            },
            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },
            uploadSuccess(response){
                if(response.error == 0){
                    this.imgList.push(response.data.path)
                }else if(response.error == 1){
                    this.$message({type: 'info', message: response.message});
                }
            },
            handleRemove(file) {
                var index=this.imgList.indexOf(file.response.data.path)
                this.imgList.splice(index)
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            confirm(InfoForm){
                this.$refs[InfoForm].validate((valid) => {
                    if(valid){
                        if(this.InfoForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.imgList.length==0){
                    this.$message.error('请上传样品图片')
                    return
                }
                this.InfoForm.dishesImg=this.imgList.join(',')
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.InfoForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesCheckRecord/Info",
                    data: this.InfoForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeInfo");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 730px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: auto;
                height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            /deep/ .is-disabled .el-input__inner {
                background-color: #F5F7FA;
                border-color: #E4E7ED;
                color: #000;
                cursor: not-allowed;
            }
            /deep/ .is-disabled .el-textarea__inner {
                background-color: #F5F7FA;
                border-color: #E4E7ED;
                color: #000;
                cursor: not-allowed;
            }
            /deep/ .is-disabled .is-checked .el-radio__inner {
                border-color: #409EFF;
                background: #409EFF;
            }
            /deep/ .is-disabled .is-checked .el-radio__inner::after {
                background: #fff;
            }
            .imgLook{
                height: 150px;
                width: 150px;
                border-radius: 5px;
            }
        }
    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
